import * as requester from '../utils/requester';

export const getAdsList = query => {
  return new Promise((resolve, reject) => {
    return requester
      .fetchAPI({
        method: 'GET',
        route: `v1/ad?${query}`
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const add = ad => {
  return new Promise((resolve, reject) => {
    return requester
      .fetchAPI({
        method: 'POST',
        route: 'v1/ad',
        data: ad
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const changeAdVisibility = (id, visibility) => {
  return new Promise((resolve, reject) => {
    return requester
      .fetchAPI({
        method: 'PUT',
        route: 'v1/ad/is-visible',
        data: {
          id,
          isVisible: visibility
        }
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const deleteAd = id => {
  return new Promise((resolve, reject) => {
    return requester
      .fetchAPI({
        method: 'DELETE',
        route: `v1/ad/${id}`
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const defaultAd = ad => {
  return new Promise((resolve, reject) => {
    return requester
      .fetchAPI({
        method: 'PUT',
        route: `v1/ad/is-default`,
        data: ad
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        reject(err);
      });
  });
};
